// 客户管理
import type { RouteRecordRaw } from 'vue-router'
import { withAccessKeyMeta } from '@/router/access-map'
import { defaultLayout } from '@/router/base'

const routes: RouteRecordRaw[] = [
  {
    path: '/order',
    name: 'Order',
    component: defaultLayout,
    meta: withAccessKeyMeta('order', {
      locale: 'common.menus.order',
      requiresAuth: true,
      icon: 'certifications',
      hideChildrenInMenu: true,
      activeMenu: 'Order',
      order: 2,
    }),
    children: [
      {
        path: '',
        name: 'IndexOrder',
        component: () => import('@/views/order/index.vue'),
        meta: {
          locale: 'common.menus.order',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Order',
          isTopMenu: true,
        },
      },
    ],
  },
]

export default routes
